/* AB-EXC-14 · Barra de niveles + regalo automático (estudio). Se apaga desde Configuración del tema. */
(() => {
  if (window.abCartLadder) return;
  const KEY = 'abRegalo';
  const MAX_MUTATIONS = 4; // máx. cambios del regalo cada 10 s: corta cualquier bucle
  let busy = false;
  let pending = false;
  let forceNext = false;
  let timer = null;
  let notice = '';
  let mutations = [];
  let lastTouch = 0;
  let booted = false; // fix2: la 1.ª sincronización no re-pinta: Liquid ya pintó el estado de la carga
  const QUIET_MS = 1000; // espera a que el cliente deje de tocar cantidades (Dawn cambia por número de línea)
  // fix3: estado de las peticiones de Dawn al carrito (las nuestras llevan el header X-AB-Regalo)
  let dawnInflight = 0;
  let dawnSeq = 0;
  let needsRepaint = false;

  const dawnIdle = () =>
    dawnInflight === 0 &&
    !document.querySelector('.cart__items--disabled') &&
    !document.querySelector('cart-drawer-items .loading__spinner:not(.hidden), cart-items .loading__spinner:not(.hidden)');

  const userActive = () => Date.now() - lastTouch < QUIET_MS || !dawnIdle();

  // fix3: Dawn cambia cantidades por número de línea. Si el regalo entra o sale, los números se corren.
  // Antes de que salga la petición de Dawn, el número de línea se cambia por la key de esa misma fila
  // (data-quantity-line-key, la que el cliente tocó). También se cuentan las peticiones de Dawn en curso.
  if (window.fetch && !window.fetch.abLadder) {
    const nativeFetch = window.fetch.bind(window);
    const wrapped = function (input, init) {
      let counted = false;
      try {
        const url = typeof input === 'string' ? input : input && input.url;
        const h = init && init.headers;
        const ours = !!(h && (h['X-AB-Regalo'] || (typeof h.get === 'function' && h.get('X-AB-Regalo'))));
        const path = url ? new URL(url, window.location.href).pathname : '';
        if (!ours && /\/cart\/(change|add|update|clear)(\.js)?$/.test(path)) {
          if (/\/cart\/change/.test(path) && init && typeof init.body === 'string') {
            const b = JSON.parse(init.body);
            if (b && b.line && !b.id) {
              const q =
                document.getElementById(`Drawer-quantity-${b.line}`) || document.getElementById(`Quantity-${b.line}`);
              const key = q && q.dataset.quantityLineKey;
              if (key) {
                delete b.line;
                b.id = key;
                init = { ...init, body: JSON.stringify(b) };
              }
            }
          }
          dawnInflight++;
          dawnSeq++;
          counted = true;
        }
      } catch (e) {}
      const p = nativeFetch(input, init);
      if (!counted) return p;
      const done = () => {
        dawnInflight = Math.max(0, dawnInflight - 1);
      };
      p.then(done, done);
      return p;
    };
    wrapped.abLadder = true;
    window.fetch = wrapped;
  }

  const cfg = () => {
    // En /cart hay dos configs (drawer + sección de página): se toma el id de sección de la que lo tenga.
    const all = [...document.querySelectorAll('[data-ab-ladder-config]')]
      .map((el) => {
        try {
          return JSON.parse(el.textContent);
        } catch (e) {
          return null;
        }
      })
      .filter(Boolean);
    if (!all.length) return null;
    const withSection = all.find((x) => x.section);
    return withSection ? { ...all[0], section: withSection.section } : all[0];
  };
  const state = () => {
    try {
      return JSON.parse(sessionStorage.getItem(KEY)) || {};
    } catch (e) {
      return {};
    }
  };
  const save = (s) => {
    try {
      sessionStorage.setItem(KEY, JSON.stringify(s));
    } catch (e) {}
  };
  const flags = (s) => {
    const root = document.documentElement.classList;
    root.toggle('ab-regalo-declined', !!s.declined);
    root.toggle('ab-regalo-oos', !!s.oos);
  };
  const isGift = (item, c) =>
    !!(item.properties && item.properties._regalo) || (item.variant_id === c.variant && item.product_type === 'Regalo');

  const sectionIds = (c) => {
    const ids = ['cart-icon-bubble'];
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    const items = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    if (items) ids.push(items.dataset.id);
    if (footer) ids.push(footer.dataset.id);
    if (c.section && document.getElementById(`shopify-section-${c.section}`)) ids.push(c.section);
    return ids;
  };

  const paint = (sections, itemCount) => {
    if (!sections) return;
    const items = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      let target = null;
      let source = null;
      if (id === 'cart-drawer') {
        target = document.querySelector('#CartDrawer .drawer__inner');
        source = doc.querySelector('.drawer__inner');
      } else if (items && id === items.dataset.id) {
        target = items.querySelector('.js-contents');
        source = doc.querySelector('#main-cart-items .js-contents');
      } else if (footer && id === footer.dataset.id) {
        target = footer.querySelector('.js-contents');
        source = doc.querySelector('#main-cart-footer .js-contents');
      } else {
        target = document.getElementById(`shopify-section-${id}`) || document.getElementById(id);
        source = doc.querySelector('.shopify-section');
      }
      // fix2: solo se reemplaza si cambió (evita re-pintar el mismo HTML)
      if (target && source && target.innerHTML !== source.innerHTML) target.innerHTML = source.innerHTML;
    });
    if (typeof itemCount === 'number') {
      const empty = itemCount === 0;
      document.querySelector('cart-drawer')?.classList.toggle('is-empty', empty);
      document.querySelector('cart-drawer-items')?.classList.toggle('is-empty', empty);
      document.querySelector('cart-items')?.classList.toggle('is-empty', empty);
      footer?.classList.toggle('is-empty', empty);
    }
  };

  const showNotice = () => {
    if (!notice) return;
    document.querySelectorAll('[data-ab-ladder-notice]').forEach((n) => (n.textContent = notice));
  };

  const refreshPageSection = (c) => {
    if (!c.section || !document.getElementById(`shopify-section-${c.section}`)) return Promise.resolve();
    return fetch(`${window.routes.cart_url}?sections=${c.section}`)
      .then((r) => r.json())
      .then((s) => paint(s))
      .catch(() => {});
  };

  // fix1 (c): tras agregar/quitar el regalo se vuelven a pedir las secciones (GET) para que los totales
  // reflejen el carrito final (códigos de descuento incluidos), aunque otra re-renderización haya llegado antes.
  const refreshSections = (c) => {
    const seq = dawnSeq;
    return fetch(`${window.routes.cart_url}?sections=${sectionIds(c).join(',')}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((s) => {
        if (!s) return;
        // fix3: si Dawn empezó otra petición mientras tanto, no se pisa su DOM; Dawn re-pinta con su respuesta
        if (seq !== dawnSeq || !dawnIdle()) {
          needsRepaint = true;
          return;
        }
        paint(s);
      })
      .catch(() => {});
  };

  const post = (url, body, c) =>
    fetch(`${url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-AB-Regalo': '1' },
      body: JSON.stringify({ ...body, sections: sectionIds(c), sections_url: window.location.pathname }),
    }).then((r) => r.json().then((j) => ({ ok: r.ok, j })));

  const allowMutation = () => {
    const now = Date.now();
    mutations = mutations.filter((t) => now - t < 10000);
    if (mutations.length >= MAX_MUTATIONS) return false;
    mutations.push(now);
    return true;
  };

  async function sync(forceAdd) {
    const c = cfg();
    if (!c || !c.variant) return;
    if (!forceAdd && userActive()) {
      schedule();
      return;
    }
    if (busy) {
      pending = true;
      forceNext = forceNext || !!forceAdd;
      return;
    }
    busy = true;
    try {
      const cart = await fetch(`${window.routes.cart_url}.js`).then((r) => r.json());
      const s = state();
      const gifts = cart.items.filter((i) => isGift(i, c));
      const giftCents = gifts.reduce((a, i) => a + i.final_line_price, 0);
      const basis = cart.items_subtotal_price - giftCents;
      const change = (line, quantity, msg) => ({ url: window.routes.cart_change_url, body: { id: line.key, quantity }, msg });
      let action = null;

      if (basis < c.threshold) {
        s.declined = false; // se re-arma al bajar del umbral
        if (gifts.length) action = change(gifts[0], 0, c.msgBelow);
      } else if (gifts.length) {
        if (c.requireFree && giftCents > 0) {
          s.declined = true;
          action = change(gifts[0], 0, c.msgNotFree);
        } else if (gifts.length > 1) {
          action = change(gifts[1], 0);
        } else if (gifts[0].quantity !== 1) {
          action = change(gifts[0], 1);
        }
      } else {
        if (forceAdd) s.declined = false;
        else if (s.hadGift) s.declined = true; // el cliente lo quitó: no se vuelve a agregar
        if (c.available && !s.oos && !s.declined && (c.mode === 'auto' || forceAdd)) {
          action = {
            url: window.routes.cart_add_url,
            body: { items: [{ id: c.variant, quantity: 1, properties: { _regalo: '1' } }] },
            msg: c.msgAdded,
            add: true,
          };
        }
      }

      // fix3: justo antes de mandar el cambio se revisa otra vez que Dawn esté quieto; si no, se re-encola
      if (action && (forceAdd ? !dawnIdle() : userActive())) {
        pending = true; // el cliente volvió a tocar el carrito: se reintenta al quedar quieto
        forceNext = forceNext || !!forceAdd;
        action = null;
      } else if (action && allowMutation()) {
        const seq = dawnSeq;
        const postedAt = Date.now();
        const res = await post(action.url, action.body, c);
        if (!res.ok) {
          if (action.add) s.oos = true; // 422 agotado: se oculta el regalo y no se reintenta
          s.hadGift = !action.add && gifts.length > 0;
        } else {
          notice = action.msg || '';
          s.hadGift = action.add ? true : action.body.quantity === 0 ? gifts.length > 1 : true;
          // fix3: si Dawn empezó una petición después de la nuestra, no se cambia su HTML (Dawn re-pinta con su
          // respuesta, que ya trae el regalo); se re-pinta en la siguiente sincronización en calma.
          if (seq === dawnSeq && lastTouch < postedAt && dawnIdle()) {
            paint(res.j.sections, action.add ? cart.item_count + 1 : res.j.item_count);
            await refreshSections(c);
          } else {
            needsRepaint = true;
            schedule();
          }
        }
      } else if (!pending) {
        s.hadGift = gifts.length > 0;
        if (needsRepaint) {
          needsRepaint = false;
          await refreshSections(c);
        } else if (booted) await refreshPageSection(c);
      }
      booted = true;
      save(s);
      flags(s);
      showNotice();
    } catch (e) {
      // silencioso: nunca bloquea el carrito
    } finally {
      busy = false;
      if (pending) {
        pending = false;
        if (forceNext) {
          forceNext = false;
          sync(true);
        } else schedule();
      }
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(() => sync(false), 300);
  }

  window.abCartLadder = { sync, schedule };

  const touch = (e) => {
    if (e.target.closest && e.target.closest('cart-drawer-items, cart-items') && !e.target.closest('[data-ab-gift-add]')) {
      lastTouch = Date.now();
      if (timer) schedule();
    }
  };
  document.addEventListener('click', touch, true);
  document.addEventListener('change', touch, true);
  document.addEventListener('input', touch, true);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ab-gift-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    sync(true);
  });

  const start = () => {
    flags(state());
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event && event.source === 'ab-regalo') return;
        notice = '';
        schedule();
      });
    }
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
